// Configuration spécifique à la marque
export const BRAND = process.env.REACT_APP_BRAND || 'acola';
